import { render, staticRenderFns } from "./floatWinData.vue?vue&type=template&id=1ec0c0ba&"
import script from "./floatWinData.vue?vue&type=script&lang=js&"
export * from "./floatWinData.vue?vue&type=script&lang=js&"
import style0 from "./floatWinData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports